import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { setPreviousPath } from '~/redux/slices/location/index';
import { useAppDispatch } from '~/redux/store/useAppDispatch';

export default function PreviousLocationTracker(): null {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  useEffect(
    () => () => {
      dispatch(setPreviousPath(pathname));
    },
    [pathname, dispatch],
  );

  return null;
}
